import { useRouter } from 'next/router'
import React, { memo } from 'react'

import MenuItems from '@/components/FloatingMenus/MenuItems'
import { getFloatingMenu } from '@/services/apps'
import clsxm from '@/utils/clsxm'
import { useAppSelector } from '@/utils/hooks'

const FloatingMenu = () => {
  const floatingMenuIsShow = useAppSelector((state) => state.floatingMenu.isShow)

  const router = useRouter()
  const { data: floatingMenu } = useAppSelector(
    getFloatingMenu.select({ headers: { 'Accept-Language': String(router.locale) } })
  )

  if (floatingMenu?.data && floatingMenu?.data.items.length) {
    return (
      <div className={clsxm('floating-container', !floatingMenuIsShow && 'hidden')}>
        {floatingMenu?.data.items.map((item) => (
          <MenuItems
            key={item.xid}
            item={item}
          />
        ))}
      </div>
    )
  }
  return null
}

export default memo(FloatingMenu)
